<template>
  <el-container v-title data-title="工作日" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学校管理</el-breadcrumb-item>
                <el-breadcrumb-item>工作日</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-calendar v-model="selectedDate">
          <template v-slot:dateCell="{data}">
            <div v-if="data.day >= date1YearAgo && date1YearAfter >= data.day" class="valid-date" :class="[(new Date(data.day).getDay() === 6 || new Date(data.day).getDay() === 0) && schoolWorkDayList.indexOf(data.day) === -1 || new Date(data.day).getDay() !== 6 && new Date(data.day).getDay() !== 0 && schoolWorkDayList.indexOf(data.day) !== -1 ? 'off-day' : '']" @click="addOrRemove(data.day)">
              <p style="margin:0;">{{ data.day.split('-').slice(1).join('月') }}日</p>
              <p style="margin:0;" v-if="(new Date(data.day).getDay() === 6 || new Date(data.day).getDay() === 0) && schoolWorkDayList.indexOf(data.day) === -1
              || new Date(data.day).getDay() !== 6 && new Date(data.day).getDay() !== 0 && schoolWorkDayList.indexOf(data.day) !== -1">休息日</p>
              <p style="margin:0;" v-if="new Date(data.day).getDay() !== 6 && new Date(data.day).getDay() !== 0 && schoolWorkDayList.indexOf(data.day) === -1
              || (new Date(data.day).getDay() === 6 || new Date(data.day).getDay() === 0) && schoolWorkDayList.indexOf(data.day) !== -1">工作日</p>
            </div>
            <div v-if="data.day > date1YearAfter || date1YearAgo > data.day" class="invalid-date">
              <p style="margin:0;">{{ data.day.split('-').slice(1).join('月') }}日</p>
            </div>
          </template>
        </el-calendar>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      schoolList: [],
      loading: false,
      searchForm: {
        schoolId: null
      },
      selectedDate: new Date(),
      today: new Date(),
      date1YearAgo: '',
      date1YearAfter: '',
      schoolWorkDayList: []
    }
  },
  created () {
    let now = Math.round(new Date().getTime() / 1000)
    if (this.Cookie.get('offsetSecond') !== undefined || this.Cookie.get('offsetSecond') !== '') {
      var offsetSecond = this.Cookie.get('offsetSecond')
      this.today = new Date(new Date((parseInt(now) + parseInt(offsetSecond)) * 1000).toISOString().split('T')[0])
      this.date1YearAgo = new Date((parseInt(now) + parseInt(offsetSecond) - 86400 * 365) * 1000).toISOString().split('T')[0]
      this.date1YearAfter = new Date((parseInt(now) + parseInt(offsetSecond) + 86400 * 365) * 1000).toISOString().split('T')[0]
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getSchoolList()
    }
  },
  methods: {
    search () {
      this.getSchoolWorkDayList()
    },
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      this.getDateToGoodsQtyMap()
      done()
    },
    changeGridStyle () {
      let closedDomList = document.querySelectorAll('.closed')
      for (let dom of closedDomList) {
        if (dom.parentNode.parentNode.className.includes('current')) {
          dom.parentNode.parentNode.style.backgroundColor = dom.parentNode.parentNode.className.includes('is-today') ? '#FFC964' : '#FFE4B5'
          dom.parentNode.parentNode.style.opacity = '1'
          dom.parentNode.parentNode.style.color = '#000'
        } else {
          dom.parentNode.parentNode.style.backgroundColor = '#FFE4B5'
          dom.parentNode.parentNode.style.opacity = '0.5'
          dom.parentNode.parentNode.style.color = '#000'
        }
      }
      let notClosedDomList = document.querySelectorAll('.notClosed')
      for (let dom of notClosedDomList) {
        if (dom.parentNode.parentNode.className.includes('current')) {
          dom.parentNode.parentNode.style.backgroundColor = '#90EE90'
          dom.parentNode.parentNode.style.opacity = '1'
          dom.parentNode.parentNode.style.color = '#000'
        } else {
          dom.parentNode.parentNode.style.backgroundColor = '#90EE90'
          dom.parentNode.parentNode.style.opacity = '0.5'
          dom.parentNode.parentNode.style.color = '#000'
        }
      }
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.searchForm.schoolId = _this.schoolList[0].id
              _this.getSchoolWorkDayList()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getSchoolWorkDayList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/schoolWorkDay/list',
        this.$qs.stringify({ schoolId: _this.searchForm.schoolId })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolWorkDayList = res.data.data
          }
        }
      })
    },
    addOrRemove (date) {
      console.log('date: ' + date)
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/schoolWorkDay/addOrRemove',
        this.$qs.stringify({
          schoolId: _this.searchForm.schoolId,
          date: date,
          type: ((new Date(date).getDay() === 6 || new Date(date).getDay() === 0) && _this.schoolWorkDayList.indexOf(date) === -1) || (new Date(date).getDay() !== 6 && new Date(date).getDay() !== 0 && _this.schoolWorkDayList.indexOf(date) !== -1) ? '1' : '2'
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.getSchoolWorkDayList()
          }
        }
      })
    }
  }
})
</script>
<style>
  .el-calendar-table td.current :hover {
    color: #0000EE;
    background-color: #06a5f9;
  }
  .grid-content {
    min-height: 25px;
    line-height: 25px;
    padding: 2px;
    text-align: center;
  }
  .el-divider--horizontal {
    margin: 5px 0;
  }
  .valid-date {
    margin:0;
    height:100%;
    background-color: #FFFFFF;
  }
  .invalid-date {
    margin:0;
    height:100%;
    background-color: #808080;
  }
  .off-day {
    background-color: #FFAAAA;
  }
</style>



// WEBPACK FOOTER //
// src/components/SchoolWorkDay.vue